<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Giacomo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Vergessen Sie den Ferrari Modulo und begrüßen Sie den Ferrari Conterno. Schlank, kraftvoll und schmerzhaft
                        begehrenswert, Giacomo Conterno nennen italienische Weinliebhaber gerne dannatamente buono.
                        Hersteller des wahrscheinlich besten Barolo Italiens (wenn nicht sogar der Welt) mit sieben Jahren im Fass
                        Es lohnt sich, auf die Weine von Giacomo Conterno zu warten, bevor sie auf den Markt kommen.
                    </div>

                    <div class="howto-title2">Das Ideal des traditionellen Barolo</div>
                    <div class="howto-text">
                        Drei Vater-Sohn-Generationen von Conternos haben jeweils das Familienerbe beachtet
                        Generation, die ihren charakteristischen Stil hinzufügt. Heute ist Roberto an der Reihe; Er teilt nicht nur
                        Er hat das Talent seines Vaters, ist aber auch in der glücklichen Lage, auf seinem aufbauen zu können
                        Großvaters Weisheit und Erfahrung. Gepaart mit einer ehrgeizigen Einstellung und einem gesunden Lebensstil
                        Respekt vor der Tradition, und vielleicht erleben Sie gerade einige der besten Giacomo Conternos
                        noch.
                        <br><br>
                        Die berühmte Langlebigkeit des Monfortino Riserva ist eine eigenständige Legende. Im Jahr 1920 hatte Giacomo
                        war gerade für den Ersten Weltkrieg zurückgekehrt und brauchte einen Beruf. Zu dieser Zeit wurde Barolo für frühe oder frühe Weine hergestellt
                        Er wurde sofort getrunken, aber Giacomo, der stets ein Visionär war, erkannte die komplexe Struktur der Trauben
                        Potenzial und schuf so den ersten Barolo, der für die Reifung geeignet war. Die erste Flasche, die er herstellte, war
                        der Barolo Riserva von 1920, der zu Ehren seines Dorfes bald zum Monfortino Riserva wurde. Leben
                        In den nächsten mehr als 50 Jahren ging es im Großen und Ganzen genauso weiter. Giacomo, später mit seinem Sohn Giovanni,
                        kaufte Trauben von den ertragsärmsten Landwirten der Region und produzierte weiterhin Spitzenprodukte
                        Barolos. Doch 1974 änderte sich alles: Er kaufte ein 16 Hektar großes, nach Südwesten ausgerichtetes Weizenanbaugebiet
                        mit der Absicht, Nebbiolo-Reben anzupflanzen. Der erste Jahrgang aus eigener Herstellung
                        Die Weintrauben stammten aus dem Jahr 1978 und der Rest ist Geschichte.
                    </div>

                    <div class="howto-title2">Der beste Barolo aller Zeiten?</div>
                    <div class="howto-text">
                        Giacomo Contorno ist berühmt für seine beiden Barolos, Cascina Francia und Monfortino. Innerhalb der
                        Weine, die unter Giovannis Leitung hergestellt wurden, finden wir viele hervorragende Jahrgänge; die 1964, 1971, 1978, 1985,
                        Da fallen mir sofort die Jahre 1996, 1999 und 2001 ein. Aber vielleicht war es sein letzter Jahrgang, der 2002er
                        der ultimative Erfolg. Acht Jahre lang in Botti (Fässern) gereift, ist der Monfortino nichts Geringeres
                        legendär. Die einzige Cuvée, die in diesem Jahr produziert wurde (d. h. keine Cascina Francia).
                        gemacht), hat es weltweit zahlreiche Fans gewonnen, darunter den einflussreichen Antonio Galloni (während
                        (schreibt immer noch für Robert Parkers Wine Advocate), der ihm satte 98 Punkte gab. Verkauf 2019
                        In Europa lagen die Preise bei über 500 Euro pro Flasche, in Asien und den Vereinigten Staaten verdoppelten sie sich fast.
                        Die jüngsten Jahrgänge haben noch nicht die herausragenden Höhen des Jahrgangs 2002 erreicht, allerdings zu einem Veröffentlichungspreis von 60 €
                        eine Flasche als Geschenk für 2019, wir erwarten Großes von diesem großartigen Produzenten.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Jahr 2019 steht der Monfortino Riserva von Giacomo Conterno an der Spitze der Liste von wine-searcher.com für den „teuersten italienischen Wein“ und belegt auch Platz 83 in der Liste der „Top 100 meistgesuchten Weine“ derselben Website Er rutscht gut in die Top 10, leicht vor dem begehrten Zweitwein des Herstellers Francia (Platz 19) für „Beste italienische Weine“.
                            </li>
                            <li>Giacomo Conterno Francia (bis 2009 Cascina Francia genannt, jedoch immer noch „Cascina“)
                                erscheint 2010 auf den Korken) darf auch als „Riserva“ in besonders guter Qualität bezeichnet werden
                                Jahre. Der Jahrgang 2015 erreichte die gleiche Gesamtpunktzahl wie der gefeierte und
                                2010 ist teuer, Anleger können sich über mehr Wachstum freuen, da Durchschnittspreise (über alle Jahrgänge hinweg)
                                sind im Zweijahreszeitraum seit Juni 2017 um +33 % gestiegen.
                            </li>
                            <li>Il Barolo Riserva Monfortino 2010 ha superato le performance nel primo trimestre della Liv-Ex's Italy 100 con un
                                incremento del +13,8%. I 100 punti “definitivi” dati da Monica di The Wine Advocate
                                Larner, osservando questo pregiato Barolo riserva “è un vino perfetto e ci sono poche cose che io
                                sono più sicuro di in questa vita”. Non c'è da meravigliarsi che i prezzi siano più che raddoppiati nei due
                                anno da giugno 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Giacomo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Vergessen Sie den Ferrari Modulo und begrüßen Sie den Ferrari Conterno. Schlank, kraftvoll und schmerzhaft
                        begehrenswert, Giacomo Conterno nennen italienische Weinliebhaber gerne dannatamente buono.
                        Hersteller des wahrscheinlich besten Barolo Italiens (wenn nicht sogar der Welt) mit sieben Jahren im Fass
                        Es lohnt sich, auf die Weine von Giacomo Conterno zu warten, bevor sie auf den Markt kommen.
                    </div>

                    <div class="howto-title2">Das Ideal des traditionellen Barolo</div>
                    <div class="howto-text">
                        Drei Vater-Sohn-Generationen von Conternos haben jeweils das Familienerbe beachtet
                        Generation, die ihren charakteristischen Stil hinzufügt. Heute ist Roberto an der Reihe; Er teilt nicht nur
                        Er hat das Talent seines Vaters, ist aber auch in der glücklichen Lage, auf seinem aufbauen zu können
                        Großvaters Weisheit und Erfahrung. Gepaart mit einer ehrgeizigen Einstellung und einem gesunden Lebensstil
                        Respekt vor der Tradition, und vielleicht erleben Sie gerade einige der besten Giacomo Conternos
                        noch.
                        <br><br>
                        Die berühmte Langlebigkeit des Monfortino Riserva ist eine eigenständige Legende. Im Jahr 1920 hatte Giacomo
                        war gerade für den Ersten Weltkrieg zurückgekehrt und brauchte einen Beruf. Zu dieser Zeit wurde Barolo für frühe oder frühe Weine hergestellt
                        Er wurde sofort getrunken, aber Giacomo, der stets ein Visionär war, erkannte die komplexe Struktur der Trauben
                        Potenzial und schuf so den ersten Barolo, der für die Reifung geeignet war. Die erste Flasche, die er herstellte, war
                        der Barolo Riserva von 1920, der zu Ehren seines Dorfes bald zum Monfortino Riserva wurde. Leben
                        In den nächsten mehr als 50 Jahren ging es im Großen und Ganzen genauso weiter. Giacomo, später mit seinem Sohn Giovanni,
                        kaufte Trauben von den ertragsärmsten Landwirten der Region und produzierte weiterhin Spitzenprodukte
                        Barolos. Doch 1974 änderte sich alles: Er kaufte ein 16 Hektar großes, nach Südwesten ausgerichtetes Weizenanbaugebiet
                        mit der Absicht, Nebbiolo-Reben anzupflanzen. Der erste Jahrgang aus eigener Herstellung
                        Die Weintrauben stammten aus dem Jahr 1978 und der Rest ist Geschichte.
                    </div>

                    <div class="howto-title2">Der beste Barolo aller Zeiten?</div>
                    <div class="howto-text">
                        Giacomo Contorno ist berühmt für seine beiden Barolos, Cascina Francia und Monfortino. Innerhalb der
                        Weine, die unter Giovannis Leitung hergestellt wurden, finden wir viele hervorragende Jahrgänge; die 1964, 1971, 1978, 1985,
                        Da fallen mir sofort die Jahre 1996, 1999 und 2001 ein. Aber vielleicht war es sein letzter Jahrgang, der 2002er
                        der ultimative Erfolg. Acht Jahre lang in Botti (Fässern) gereift, ist der Monfortino nichts Geringeres
                        legendär. Die einzige Cuvée, die in diesem Jahr produziert wurde (d. h. keine Cascina Francia).
                        gemacht), hat es weltweit zahlreiche Fans gewonnen, darunter den einflussreichen Antonio Galloni (während
                        (schreibt immer noch für Robert Parkers Wine Advocate), der ihm satte 98 Punkte gab. Verkauf 2019
                        In Europa lagen die Preise bei über 500 Euro pro Flasche, in Asien und den Vereinigten Staaten verdoppelten sie sich fast.
                        Die jüngsten Jahrgänge haben noch nicht die herausragenden Höhen des Jahrgangs 2002 erreicht, allerdings zu einem Veröffentlichungspreis von 60 €
                        eine Flasche als Geschenk für 2019, wir erwarten Großes von diesem großartigen Produzenten.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Jahr 2019 steht der Monfortino Riserva von Giacomo Conterno an der Spitze der Liste von wine-searcher.com für den „teuersten italienischen Wein“ und belegt auch Platz 83 in der Liste der „Top 100 meistgesuchten Weine“ derselben Website Er rutscht gut in die Top 10, leicht vor dem begehrten Zweitwein des Herstellers Francia (Platz 19) für „Beste italienische Weine“.
                            </li>
                            <li>Giacomo Conterno Francia (bis 2009 Cascina Francia genannt, jedoch immer noch „Cascina“)
                                erscheint 2010 auf den Korken) darf auch als „Riserva“ in besonders guter Qualität bezeichnet werden
                                Jahre. Der Jahrgang 2015 erreichte die gleiche Gesamtpunktzahl wie der gefeierte und
                                2010 ist teuer, Anleger können sich über mehr Wachstum freuen, da Durchschnittspreise (über alle Jahrgänge hinweg)
                                sind im Zweijahreszeitraum seit Juni 2017 um +33 % gestiegen.
                            </li>
                            <li>Der Barolo Riserva Monfortino aus dem Jahr 2010 übertraf die Leistungen im ersten Quartal des Italy 100 von Liv-Ex mit einem
                                Steigerung um +13,8 %. Die „ultimativen“ 100 Punkte von Monica von The Wine Advocate
                                Larner bemerkte, dass dieser geschätzte Riserva Barolo „ein perfekter Wein ist und es gibt nur wenige Dinge, die mir gefallen.“
                                Ich bin mir in diesem Leben sicherer“. Kein Wunder, dass sich die Preise in beiden Ländern mehr als verdoppelt haben
                                Jahreszeitraum seit Juni 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Giacomo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Oubliez la Ferrari Modulo et dites bonjour à la Ferrari Conterno. Élégant, puissant et douloureux
                        convoité, Giacomo Conterno est ce que les amateurs de vins italiens aiment appeler dannatamente buono.
                        Producteurs de probablement le meilleur barolo d'Italie (sinon du monde), avec sept ans en fût
                        avant de sortir, les vins de Giacomo Conterno valent la peine d'être attendus.
                    </div>

                    <div class="howto-title2">L'idéal du Barolo traditionnel</div>
                    <div class="howto-text">
                        Trois générations père/fils de Conternos ont été attentives à l'héritage familial, chacune
                        génération ajoutant leur style de signature. Aujourd'hui c'est au tour de Roberto ; non seulement il partage
                        le talent de son père, mais il est aussi dans la position heureuse où il peut s'appuyer sur son
                        la sagesse et l'expérience de grand-père. Couplé avec une attitude ambitieuse et une saine
                        respect de la tradition, et vous pourriez découvrir quelques-uns des meilleurs Giacomo Conternos
                        encore.
                        <br><br>
                        La célèbre longévité de la Monfortino Riserva est une légende à part entière. En 1920, Giacomo avait
                        vient de rentrer pour la Première Guerre mondiale et avait besoin d'une profession. A l'époque, le Barolo était fait pour le début ou
                        consommation immédiate mais Giacomo, toujours visionnaire, a vu la structure complexe des raisins
                        potentiel et crée ainsi le premier Barolo de garde. La première bouteille qu'il a faite était
                        la Barolo Riserva de 1920, qui devint bientôt la Monfortino Riserva en l'honneur de son village. Vie
                        poursuivi à peu près la même chose pendant les 50 années suivantes. Giacomo, puis plus tard avec son fils Giovanni,
                        a acheté des raisins aux agriculteurs les moins productifs de la région et a continué à produire des vins superlatifs
                        Barolos. Mais en 1974, tout change : il achète un champ de blé de 16 hectares orienté sud-ouest
                        champ, avec l'intention de planter des vignes Nebbiolo. Le premier millésime réalisé avec ses propres
                        raisins était en 1978 et le reste appartient à l'histoire.
                    </div>

                    <div class="howto-title2">Le meilleur Barolo jamais créé ?</div>
                    <div class="howto-text">
                        Giacomo Contorno est célèbre pour ses deux barolos, Cascina Francia et Monfortino. Au sein de la
                        vins élaborés sous la commande de Giovanni, on trouve de nombreux millésimes superbes; les 1964, 1971, 1978, 1985,
                        1996, 1999 et 2001 me viennent à l'esprit. Mais c'était peut-être son dernier millésime, le 2002 qui
                        le succès ultime. Vieilli pendant huit ans en botti (fût), le Monfortino n'est rien de moins que
                        légendaire. La seule cuvée à avoir été produite cette année-là (c'est-à-dire qu'aucune Cascina Francia n'a été
                        fait), il a gagné des dizaines de fans dans le monde entier, y compris l'influent Antonio Galloni (alors
                        écrivant toujours pour le Wine Advocate de Robert Parker) qui lui a attribué 98 points. vente 2019
                        les prix dépassaient 500 € la bouteille en Europe, doublant presque en Asie et aux États-Unis.
                        Les millésimes récents n'ont pas encore atteint les sommets stellaires du 2002, mais à un prix de sortie de 60 €
                        une bouteille sous caution pour 2019, on attend beaucoup de ce grand producteur.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>En 2019, le Monfortino Riserva de Giacomo Conterno se retrouve en tête de la liste de wine-searcher.com pour le « vin italien le plus cher » et occupe également la 83e position sur la liste du même site pour le « Top 100 des vins les plus recherchés » comme glisse bien dans le top 10, légèrement devant le très convoité deuxième vin du producteur Francia (au numéro 19) pour les «Meilleurs vins italiens».
                            </li>
                            <li>Giacomo Conterno Francia (labellisé Cascina Francia jusqu'en 2009 mais "Cascina" toujours
                                apparaît sur les bouchons en 2010) peut également être étiqueté comme un "Riserva" en particulièrement bon
                                années. Le millésime 2015 obtenant le même score global que le célèbre et
                                cher 2010, les investisseurs peuvent profiter d'une plus grande croissance en tant que prix moyens (sur tous les millésimes)
                                ont augmenté de +33% sur la période de deux ans depuis juin 2017.
                            </li>
                            <li>Le Barolo Riserva Monfortino 2010 a dépassé les performances du premier trimestre de l'Italie 100 de Liv-Ex avec un
                                hausse de +13,8%. Les 100 points « ultimes » donnés par Monica de The Wine Advocate
                                Larner, notant que ce précieux riserva Barolo "est un vin parfait et il y a peu de choses que je
                                suis plus sûr de moi dans cette vie ». Il n'est pas étonnant que les prix aient plus que doublé dans les deux
                                année depuis juin 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Giacomo Conterno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Forget the Ferrari Modulo, and say hello to the Ferrari Conterno. Sleek, powerful and achingly
                        covetable, Giacomo Conterno is what Italian wine enthusiasts like to call dannatamente buono.
                        Producers of probably the best Barolo in Italy (if not the world), with seven years in cask
                        before releasing, Giacomo Conterno’s wines are well worth waiting for.
                    </div>

                    <div class="howto-title2">The ideal of traditional Barolo</div>
                    <div class="howto-text">
                        Three father/son generations of Conternos have paid heed to the family legacy, with each
                        generation adding their signature style. Today it is the turn of Roberto; not only does he share
                        his father’s talent, but he is also in the happy position whereby he can build on his
                        grandfather’s wisdom and experience. Coupled together with an ambitious attitude and a healthy
                        respect for tradition, and you might just be experiencing some of the finest Giacomo Conternos
                        yet.
                        <br><br>
                        The famed longevity of the Monfortino Riserva is a legend in its own right. In 1920 Giacomo had
                        just returned for WWI and needed a profession. At the time, Barolo was made for early or
                        immediate drinking but Giacomo, ever the visionist, saw the complex structure of the grapes
                        potential and thus created the first Barolo to be made for ageing. The first bottle he made was
                        the 1920 Barolo Riserva, which soon became the Monfortino Riserva in honour of his village. Life
                        carried on much the same for the next 50 plus years. Giacomo, then later with his son Giovanni,
                        purchased grapes from the region’s lowest yielding farmers, and continued to make superlative
                        Barolos. However, in 1974 all that changed: he purchased a 16-hectare south-west facing wheat
                        field, with the intention of planting Nebbiolo vines. The first vintage made using his own
                        grapes was in 1978 and the rest is history.
                    </div>

                    <div class="howto-title2">The best Barolo ever made?</div>
                    <div class="howto-text">
                        Giacomo Contorno is famed for their two Barolos, Cascina Francia and Monfortino. Within the
                        wines made under Giovanni’s command, we find many superb vintages; the 1964, 1971, 1978, 1985,
                        1996, 1999, and 2001 all spring to mind. But perhaps it was his last vintage, the 2002 that was
                        the ultimate success. Aged for eight years in botti (cask), the Monfortino is nothing short of
                        legendary. The only cuvée to have been produced for that year (i.e. no Cascina Francia was
                        made), it has earned scores of fans worldwide, including the influential Antonio Galloni (while
                        still writing for Robert Parker’s Wine Advocate) who gave it a whopping 98 points. 2019 selling
                        prices were upwards of €500 a bottle in Europe, almost doubling in Asia and the United States.
                        Recent vintages have yet to reach the stellar heights of the 2002, but at a release price of €60
                        a bottle in bond for 2019, we expect great things from this great producer.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>In 2019, Giacomo Conterno’s Monfortino Riserva finds itself topping wine-searcher.com’s list for “Most Expensive Italian Wine” and is also found holding position number 83 among the same site’s list for “Top 100 Most Searched-for Wines” as well sliding into the top 10, slightly ahead of the producer’s highly desirable second wine Francia (at number 19) for “Best Italian Wines”.
                            </li>
                            <li>Giacomo Conterno Francia (labelled Cascina Francia until 2009 though “Cascina” still
                                appears on the corks in 2010) may also be labelled as a “Riserva” in particularly good
                                years. With 2015’s vintage garnering the same aggregate score as the celebrated and
                                pricey 2010, investors can enjoy more growth as average prices (across all vintages)
                                have risen +33% over the two year period since June 2017.
                            </li>
                            <li>2010 Barolo Riserva Monfortino topped performances in Q1 on Liv-Ex’s Italy 100 with an
                                increase of +13.8%. The “ultimate” 100 points given by The Wine Advocate’s Monica
                                Larner, noting this prized riserva Barolo “is a perfect wine and there are few things I
                                am more sure of in this life”. It’s no wonder prices have more than doubled in the two
                                year period since June 2017.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GiuseppeMascarelloFiglio",
    head: {
        title: 'Giacomo Conterno | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Giacomo Conterno, a renowned wine producer in the Piedmont region of Italy. Experience the rich history and passion behind every bottle of Barolo, Barbaresco and Moscato.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {
                report: 'Giuseppe Mascarello e Figlio',
                src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
            },
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
